import { RouteSectionProps } from "@solidjs/router";
import { Show, Suspense } from "solid-js";
import { WebStoreContextProvider } from "~/context/webstore_context";
import { ThreeDotLoader } from "~/widgets/button";

export default function StoreLayout(props: RouteSectionProps) {
  return <WebStoreContextProvider>{props.children}</WebStoreContextProvider>;
}
